import { withStyles, Tab, Tabs as MaterialTabs } from "@material-ui/core";
import React from "react";

export const CustomTabs = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,

    "& .MuiTabs-scrollButtons.Mui-disabled": {
      opacity: 0.3,
    },
  },
  indicator: {
    backgroundColor: (props: any) =>
      !props.disableIndicator ? theme.palette.secondary.main : "transparent",
  },
}))((props: any) => (
  <MaterialTabs
    {...props}
    variant="scrollable"
    allowScrollButtonsMobile
    scrollButtons="auto"
  />
));

export const CustomTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    minWidth: 40,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    paddingRight: theme.spacing(0),
    paddingLeft: theme.spacing(0),

    "&$selected": {
      color: theme.palette.secondary.main,
      fontWeight: theme.typography.fontWeightRegular,
    },
    "&:focus": {
      color: theme.palette.secondary.main,
    },
  },
  selected: {},
}))((props: any) => <Tab disableRipple wrapped={false} {...props} />);
